module.exports = __webpack_public_path__ + "img/vn_qrcode_tk.329d414.png";